module.exports = __webpack_public_path__ + "static/bike-camp-zoom-c12c9a4448156214b297aa0ad734b23d.jpg";